/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { Route } from 'react-router-dom'

const LoginPage = lazy(() => import('@/pages/auth/LoginPage').then((m) => ({ default: m.LoginPage })))
const RegisterPage = lazy(() => import('@/pages/auth/RegisterPage').then((m) => ({ default: m.RegisterPage })))
const SetPasswordPage = lazy(() => import('@/pages/auth/SetPasswordPage').then((m) => ({ default: m.SetPasswordPage })))
const DeleteAccountPage = lazy(() =>
  import('@/pages/auth/DeleteAccountPage').then((m) => ({ default: m.DeleteAccountPage })),
)
const ForgotPasswordPage = lazy(() =>
  import('@/pages/auth/ForgotPasswordPage').then((m) => ({ default: m.ForgotPasswordPage })),
)
const CallbackPage = lazy(() => import('@/pages/auth/CallbackPage').then((m) => ({ default: m.CallbackPage })))
const AccountRestorePage = lazy(() =>
  import('@/pages/auth/AccountRestorePage').then((m) => ({ default: m.AccountRestorePage })),
)
const ForbiddenPage = lazy(() => import('@/pages/auth/ForbiddenPage').then((m) => ({ default: m.ForbiddenPage })))

export function authRoutes() {
  return (
    <>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/set-password/:token" element={<SetPasswordPage />} />
      <Route path="/delete-account/:token" element={<DeleteAccountPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/auth/callback" element={<CallbackPage />} />
      <Route path="/account/restore" element={<AccountRestorePage />} />
      <Route path="/forbidden" element={<ForbiddenPage />} />
    </>
  )
}
